import React, { useState, useEffect } from 'react';
import { Table, Button, message } from 'antd';
import { EyeOutlined, CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import ImageSubCategory from './ImageSubCategory';

interface ImageSubCategoryData{
    imageSubCategoryId:string;
    imageSubCategoryName:string;
    isActive:boolean;
    createdBy:string;
    createdDate:string;
    updatedBy:string;
    updatedDate:string;
    imageCategoryName:string;
}

const DisplayImageSubCategory: React.FC = () => {
  const [imagesubcategorydata, setData] = useState<ImageSubCategoryData[]>([]);
  const [isAddImageSubCategoryVisible, setIsAddImageSubCategoryVisible] = useState(false);
  const [isEditImageSubCategoryVisible, setIsEditImageSubCategoryVisible] = useState('');
  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
      }, []);

      useEffect(() => {
        getImageSubCategoryData();
      }, [isAddImageSubCategoryVisible]);

      const userId = localStorage.getItem("UserId");

      const getImageSubCategoryData = async () => {
        try {
          const token = await fetchToken();
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ImageSubCategory/GetImageSubCategory/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          setData(response.data);

        } catch (error) {
          console.error("Error fetching image sub category details", error);
        }
      };

      const handleDeleteImageSubCategoryData = async (imagesubcategoryId: string) => {
        const confirmed = window.confirm('Are you sure you want to delete this item?');
        if(confirmed){
          try {
            const token = await fetchToken();
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/ImageSubCategory/DeleteImageSubCategory`, 
              null,
            {
              params:{
                sub_category_id: imagesubcategoryId,
                user_id: userId
              },
              headers: {
                Authorization: `Bearer ${token}`
              }
            });
            message.success('Image Sub Category deleted successfully');
            getImageSubCategoryData();
          } catch (error) {
            console.error("Error deleting details", error);
          }
        }
      };

      const handleEidtImageSubCategoryData = async (imagesubcategoryId: string) => {
        setIsEditImageSubCategoryVisible(imagesubcategoryId);
        setIsAddImageSubCategoryVisible(!isAddImageSubCategoryVisible);
      };

      const columns = [
          {
            title: 'Category Name',
            dataIndex: 'imageCategoryName',
            key: 'imageCategoryName',
          },
          {
            title: 'Sub Category Name',
            dataIndex: 'imageSubCategoryName',
            key: 'imageSubCategoryName',
          },
          {
            title: 'Status',
            dataIndex: 'isActive',
            key: 'isActive',
            render: (text: boolean) => (text?"Active":"InActive"),
          },
          {
            title: 'Actions',
            dataIndex: 'actions',
            render: (_: any, record: ImageSubCategoryData) => (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button icon={<DeleteOutlined />} onClick={() => handleDeleteImageSubCategoryData(record.imageSubCategoryId)}>Delete</Button>
                <Button icon={<EditOutlined />} onClick={() => handleEidtImageSubCategoryData(record.imageSubCategoryId)}>Edit</Button>
              </div>
            ),
          },
        ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
              <Button type="primary" onClick={() => setIsAddImageSubCategoryVisible(false)} style={{ marginRight: 8 }}>
                View Image Sub Category
              </Button>
              <Button type="primary" onClick={() => {
                setIsAddImageSubCategoryVisible(true);
                setIsEditImageSubCategoryVisible('');
              }} style={{ marginRight: 8 }}>
                Add Image Sub Category
              </Button>
      </div>
              {isAddImageSubCategoryVisible ? (<ImageSubCategory imgsubcategoryid={isEditImageSubCategoryVisible} />) : (<Table dataSource={imagesubcategorydata} columns={columns} rowKey="imageSubCategoryId" />)}
    </div>
  );
};

export default DisplayImageSubCategory;